import { atom, selector } from "recoil";

const ADDITIONAL_ALTITUDE = 2000;

const csAdjustVerticalZoomWithRouteState = atom({
  key: 'csAdjustVerticalZoomWithRouteState',
  default: {
    adjust: true,
    update: false,
    marginTopFeet: ADDITIONAL_ALTITUDE,
    revision: 0
  }
});

export const csAdjustVerticalZoomWithRouteSelector = selector({
  key: 'csAdjustVerticalZoomWithRouteSelector',
  get: ({get}) => get(csAdjustVerticalZoomWithRouteState),
  set: ({set}, newValue) => {
    set(csAdjustVerticalZoomWithRouteState, {...newValue, ...{revision: newValue.revision + 1}});
  }
});
